import CardModifier from './CardModifier';
import GameObject from '../../../../GameObject/GameObject';
import Armature from '../../../Armature';

export default class FogModifier extends CardModifier {
    onCreate(params: any): void {
        super.onCreate(params);

        const fogArmature = GameObject.Instantiate(Armature, {
            name: 'fogContainer',
            dragonbonesName: 'CardsVFX',
            armatureName: 'FogCard_Overlay',
            animationName: 'fog03',
        });

        this.addChild(fogArmature);
    }
}
